// extracted by mini-css-extract-plugin
export default {"Header":"Header_Header__uTPW6","NavLogo":"Header_NavLogo__iuuac","NavRight":"Header_NavRight__K4Av-","Burger":"Header_Burger__+PtN6","Items":"Header_Items__PnPWe"};